import {isDateInPeriod, isSamePeriod} from '../../../../utils/helper'

const getListaHotels = function (state) {
  let list = []
  state.hotels.list.forEach(item => {
    item.list.forEach(item => {
      list.push({...item})
    })
  })
  return list
}

const getSelectedHotelsByPeriod = (state) => (period) => {
  const item = state.hotels.list.find(item => {
    return isSamePeriod(item.period, period)
  })
  if (!item) return []
  return item.selected
}

const getSelectedHotelsByDay = (state) => (day) => {
  const items = state.hotels.list.filter(item => {
    return isDateInPeriod(day, item.period)
  })
  if (!items || items.length === 0) return []
  return items.map(item => item.selected).reduce((t, c) => t.concat(c))
}

const getSelectedHotelsByIndex = (state) => (index) => {
  return state.hotels.list[index].selected
}

const hotelSelectedCounter = (state) => {
  let counter = 0
  state.hotels.list.forEach(item => {
    counter += item.selected ? item.selected.length : 0
  })
  return counter
}

const getHotelPeriods = (state) => {
  return state.hotels.list
}

const getSelectedHotelPeriods = (state) => {
  let list = []
  state.hotels.list.forEach(item => {
    if (item.selected.length > 0) {
      list.push(item.period)
    }
  })
  return list
}

const getSelectedHotels = (state) => {
  let list = []
  state.hotels.list.forEach(item => {
    list = list.concat(item.selected)
  })
  return list
}

const getHotelsFilter = function (state) {
  return {...state.hotels.filter}
}

const getHotelsOrder = function (state) {
  return {...state.hotels.order}
}

export default {
  getHotelPeriods,
  getListaHotels,
  getHotelsFilter,
  getSelectedHotelsByPeriod,
  getSelectedHotelsByDay,
  getSelectedHotelsByIndex,
  hotelSelectedCounter,
  getSelectedHotelPeriods,
  getSelectedHotels,
  getHotelsOrder
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/getters/hotel.js